{
  "version": 1,
  "asset_id": "25e409e9-d034-4485-8866-679aef5c8ccd",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/25e409e9-d034-4485-8866-679aef5c8ccd/gastric-bypass-diagram-406.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/25e409e9-d034-4485-8866-679aef5c8ccd/gastric-bypass-diagram-406.webp",
  "original_filename": "gastric-bypass-diagram-406.webp",
  "size": 18786,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:12:53Z"
}
